import { moderationApi } from "../store/api/moderationApi";
import { runMutation, runQuery } from "../store/api/runtime";

export const reportUser = async (
  reporterId: string,
  targetUserId: string,
  reason: string,
  details: string,
): Promise<unknown> =>
  runMutation(moderationApi.endpoints.reportUser.initiate, { reporterId, targetUserId, reason, details });

export const blockUser = async (userId: string, targetUserId: string): Promise<unknown> =>
  runMutation(moderationApi.endpoints.blockUser.initiate, { userId, targetUserId });

export const unblockUser = async (userId: string, targetUserId: string): Promise<unknown> =>
  runMutation(moderationApi.endpoints.unblockUser.initiate, { userId, targetUserId });

export const getBlockedUsers = async (userId: string): Promise<unknown> =>
  runQuery(moderationApi.endpoints.getBlockedUsers.initiate, userId);

export const isUserBlocked = async (userId: string, targetUserId: string): Promise<unknown> =>
  runQuery(moderationApi.endpoints.isUserBlocked.initiate, { userId, targetUserId });

export const requestAccountDeletion = async (userId: string): Promise<unknown> =>
  runMutation(moderationApi.endpoints.requestAccountDeletion.initiate, userId);

export const cancelAccountDeletion = async (userId: string): Promise<unknown> =>
  runMutation(moderationApi.endpoints.cancelAccountDeletion.initiate, userId);
